import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { toMap } from 'ckeditor5/src/utils';

export class HeadingAttribute extends Plugin {
  init() {
    const editor = this.editor;
    const model = editor.model;
    const conversion = editor.conversion;

    // 属性値を許可(headingを変更時にid属性値が消えてしまうことを防ぐ)
    editor.model.schema.extend('paragraphSupplementSubhead', { allowAttributes: 'htmlPAttributes' });
    editor.model.schema.extend('paragraphSupplementPara', { allowAttributes: 'htmlPAttributes' });
    editor.model.schema.extend('paragraphReferGear', { allowAttributes: 'htmlPAttributes' });
    editor.model.schema.extend('warningListTitle', { allowAttributes: 'htmlPAttributes' });
    editor.model.schema.extend('illustHeadline', { allowAttributes: 'htmlPAttributes' });
    editor.model.schema.extend('customGroup', { allowAttributes: 'htmlPAttributes' });
    editor.model.schema.extend('customItem', { allowAttributes: 'htmlPAttributes' });
    editor.model.schema.extend('paragraphRefer1', { allowAttributes: 'htmlPAttributes' });

    editor.conversion.for('downcast').add((dispatcher) => {
      dispatcher.on('attribute:htmlPAttributes:paragraphSupplementSubhead', (evt, data, conversionApi) => {
        AttributeSet(data, conversionApi);
      });
      dispatcher.on('attribute:htmlPAttributes:paragraphSupplementPara', (evt, data, conversionApi) => {
        AttributeSet(data, conversionApi);
      });
      dispatcher.on('attribute:htmlPAttributes:paragraphReferGear', (evt, data, conversionApi) => {
        AttributeSet(data, conversionApi);
      });
      dispatcher.on('attribute:htmlPAttributes:warningListTitle', (evt, data, conversionApi) => {
        AttributeSet(data, conversionApi);
      });
      dispatcher.on('attribute:htmlPAttributes:illustHeadline', (evt, data, conversionApi) => {
        AttributeSet(data, conversionApi);
      });
      dispatcher.on('attribute:htmlPAttributes:customGroup', (evt, data, conversionApi) => {
        AttributeSet(data, conversionApi);
      });
      dispatcher.on('attribute:htmlPAttributes:customItem', (evt, data, conversionApi) => {
        AttributeSet(data, conversionApi);
      });
      dispatcher.on('attribute:htmlPAttributes:paragraphRefer1', (evt, data, conversionApi) => {
        AttributeSet(data, conversionApi);
      });
    });

    /*
    // 上のdispatcherイベントはこれでOKだと思うが影響が大きいのでとりあえず使用しない
    editor.conversion.for('downcast').add((dispatcher) => {
      dispatcher.on('attribute:htmlPAttributes', (evt, data, conversionApi) => {
        console.log('hit');
        AttributeSet(data, conversionApi);
      });
    });
    */

    var AttributeSet = function (data, conversionApi) {
      //console.log(data);
      const viewWriter = conversionApi.writer;
      if (data.attributeNewValue != null) {
        //console.log(data.attributeNewValue.attributes);
        const attributes = toMap(data.attributeNewValue.attributes);
        // console.log(attributes);
        for (const [key, val] of attributes) {
          if (key === 'class') {
            //writer.addClass( val, linkInImage );
          } else {
            //console.log(`key:${key}  val:${val}`);
            viewWriter.setAttribute(key, val, conversionApi.mapper.toViewElement(data.item));
          }
        }
      }
    };
  }
}
